import React, { Fragment, useCallback, useMemo, useRef } from 'react';
import { useToggle } from 'react-use';
import { v4 } from 'uuid';
import { DownloadIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import Menu from 'components/shared/Menu';

function DiagnosticPackageDownloadButton({ deviceId, diagPkgId, decrypted, encrypted, createdTime, onDownload }) {
  const menuId = useMemo(() => v4(), []);
  const buttonRef = useRef(null);
  const [opened, toggleOpened] = useToggle(false);
  const handleClose = useCallback(() => {
    toggleOpened(false);
  }, [toggleOpened]);
  const handleClick = useCallback(
    (isDecrypted) => {
      onDownload({ deviceId, diagPkgId, createdTime, isDecrypted });
    },
    [deviceId, diagPkgId, createdTime, onDownload]
  );

  if (decrypted && encrypted) {
    return (
      <Fragment>
        <IconButton
          ref={buttonRef}
          aria-label="Download"
          aria-haspopup={true}
          aria-controls={menuId}
          variant="text"
          color="primary"
          size="small"
          onClick={toggleOpened}
        >
          <DownloadIcon />
        </IconButton>
        <Menu id={menuId} aria-label="Download" anchor={buttonRef.current} open={opened} onClose={handleClose}>
          <Menu.Item onClick={() => handleClick(false)}>Encrypted</Menu.Item>
          <Menu.Item onClick={() => handleClick(true)}>Decrypted</Menu.Item>
        </Menu>
      </Fragment>
    );
  }

  return (
    <IconButton
      aria-label="Download"
      variant="text"
      color="primary"
      size="small"
      onClick={() => handleClick(decrypted)}
    >
      <DownloadIcon />
    </IconButton>
  );
}

export default DiagnosticPackageDownloadButton;
